import { cn } from '@codes/ui-kit/utils';

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
    return <div className={cn('animate-pulse rounded-md bg-badge', className)} {...props} />;
}

export { Skeleton };
